// extracted by mini-css-extract-plugin
export default {"container":"AboutThisHome_container__CH+bv","description":"AboutThisHome_description__oEKTU"};